import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/revenue-subscriptions")({
  head: () => ({ meta: [{ title: "Subscriptions · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Subscriptions"
      description="All active subscriptions with plan, billing cycle, and renewal."
      stats={[
        { label: "Active subscriptions" },
        { label: "Monthly subscribers" },
        { label: "Yearly subscribers" },
        { label: "Trial subscribers" },
      ]}
      body="Active subscriptions table will appear here."
      primaryAction={{ label: "Export", icon: Download }}
      columns={["Customer", "Plan", "Cycle", "MRR", "Renews", "Status"]}
    />
  ),
});
